//#region src/tenants/demo/routing.ts
/**
* Demo provider ranking — currently identical to HHB values, but a full copy
* so Demo can diverge without editing HHB. Ranking applies to UI/ORPC search
* and to the full referral agent (`packages/services/src/harnesses/demo/`).
*/
const demoProviderRouting = { ranking: {
	mode: "sequentialOverwrite",
	pipeline: [
		"insurance",
		"location",
		"providerName",
		"organizationName"
	]
} };

//#endregion
export { demoProviderRouting };